import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function Tab({ active, children, className }) {
	return (
		<div className={classnames('tab-pane', className, { active })}>
			{children}
		</div>
	);
}

Tab.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	active: PropTypes.bool,
};
